import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axiosInstance from "../../axiosInstance";

function ResetPassword() {
  const { token } = useParams(); // for token from the URL
  // console.log('Token', token);
  const history = useHistory();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const validateForm = () => {
    if (!password.trim()) {
      setError("Password is required.");
      return false;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!validateForm()) {
      return;
    }

    try {
      const response = await axiosInstance.post("/users/verifyResetToken", {
        password,
        token,
      });

      if (response.data.success) {
        setMessage("Password has been reset successfully.");
        setTimeout(() => {
           history.push("/auth/login"); // Redirect to login page after successful reset
        }, 3000);
      } else {
        setError(response.data.error.message || "Password reset failed!");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
        setError(err.response.data.error.message);
      } else {
        setError("An error occurred during password reset.");
      }
    }
  };

  useEffect(() => {
    if (!token) {
      setError("Invalid or missing reset token.");
    }
  }, [token]);

  return (
    <Col md={5} className="p-5 bg-white full-height">
      <div className="login-main-left">
        <div className="text-center mb-5 login-main-left-header pt-4">
          <a href="https://autotrak.ai/">
          <img src="/img/logo-autotrak.png" className="img-fluid" alt="LOGO" />
          </a>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Form.Group>

          <div className="mt-4">
            <Row>
              <Col>
                <Button type="submit" variant="outline-primary" size="lg" block>
                  Reset Password
                </Button>
              </Col>
            </Row>
          </div>

          {error && <p className="text-danger mt-3">{error}</p>}
          {message && <p className="text-success mt-3">{message}</p>}
        </Form>
      </div>
    </Col>
  );
}

export default ResetPassword;
